<div class="dashboard-box p-4">
  <div class="flex flex-col md:flex-row md:items-center md:justify-center gap-20">
    <div class="flex flex-col items-center">
      <div class="text-gray-500 text-sm mb-1">Partner</div>
      <div class="text-xl font-bold">{{ getFullName() }}</div>
      <div *ngIf="partnerInfo.name && partnerInfo.phone" class="text-sm text-gray-600 mt-1">
        {{ partnerInfo.phone }}
      </div>
    </div>
    <div class="flex flex-col items-center">
      <div class="text-gray-500 text-sm mb-1">{{ 'BTB.DASHBOARD.PARTNER_ID' | translate }}</div>
      <div class="flex items-center gap-2">
        <div class="text-xl font-bold">{{ partnerInfo.partnerId || ('BTB.NOT_SET' | translate) }}</div>
        <button 
          *ngIf="showCopyButton && partnerInfo.partnerId"
          (click)="onCopyRegistrationLink()"
          class="p-2 text-gray-600 hover:text-gray-800 transition-colors"
          [title]="'BTB.DASHBOARD.COPY_REGISTRATION_LINK' | translate">
          <mat-icon class="text-sm">content_copy</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="showEmail" class="flex flex-col items-center">
      <div class="text-gray-500 text-sm mb-1">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.EMAIL' | translate }}</div>
      <div class="text-lg">{{ partnerInfo.email }}</div>
    </div>
    <div class="flex flex-col items-center">
      <div class="text-gray-500 text-sm mb-1">{{ 'BTB.DASHBOARD.ASSOCIATED_CLIENTS' | translate }}</div>
      <div class="text-xl font-bold">{{ partnerInfo.numClients }}</div>
    </div>
  </div>
</div>
